import React from 'react';
import styles from 'src/scenarios';
import { DragSource, DropTarget } from 'react-dnd';

class SortListItem extends React.Component {
  onFieldCodeChange = (e) => {
    e.preventDefault();
    var key = e.target.value;
    var r = { ...this.props.data };
    this.props.field_options.forEach((opt) => {
      if (opt.code == key) {
        r.field_type = opt.type;
        r.field_code = opt.code;
        r.field_label = opt.label;
        r.sort_order = 'asc';
        this.props.onChange(this.props.index, 'sort_fields', r);
      }
    });
  };

  handleOrderChange = (e) => {
    var props = {
      sort_order: e.target.value,
    };
    var r = { ...this.props.data, ...props };
    this.props.onChange(this.props.index, 'sort_fields', r);
  };

  onAdd = (e) => {
    e.preventDefault();
    this.props.onAdd(this.props.index, 'sort_fields');
  };

  onRemove = (e) => {
    e.preventDefault();
    this.props.onRemove(this.props.index, 'sort_fields');
  };

  render() {
    if (
      !this.props.connectDragPreview ||
      !this.props.connectDragSource ||
      !this.props.connectDropTarget
    )
      return;

    return this.props.connectDragPreview(
      this.props.connectDropTarget(
        <div className="row">
          <div className="col-sm-1">
            {this.props.connectDragSource(
              <button type="button" className="btn-sm handle text-center">
                <i className="material-icons">reorder</i>
              </button>,
              { dropEffect: 'move' },
            )}
          </div>
          <div className="col-sm-5">
            <select
              className="form-control"
              id={this.props.id}
              value={this.props.data.field_code || ''}
              onChange={this.onFieldCodeChange}
            >
              <option key="#blank" value="" />
              {this.props.field_options.map((o) => {
                return (
                  <option key={o.code} value={o.code}>
                    {o.label}
                  </option>
                );
              })}
            </select>
          </div>
          <div className="col-sm-2">
            <select
              className="form-control"
              value={this.props.data.sort_order || 'asc'}
              onChange={this.handleOrderChange}
            >
              <option value="asc">昇順</option>
              <option value="desc">降順</option>
            </select>
          </div>
          <div className="col-sm-4 align-self-center">
            <span className={styles.buttons}>
              <a href="#!" onClick={this.onAdd}>
                <i className="material-icons mr-1">add_circle</i>
              </a>
              {this.props.removable && (
                <a href="#!" onClick={this.onRemove}>
                  <i className="material-icons mr-1">remove_circle</i>
                </a>
              )}
            </span>
          </div>
        </div>,
      ),
    );
  }
}

const itemSource = {
  beginDrag(props) {
    return props;
  },
};

function collectSource(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging(),
  };
}

const itemTarget = {
  hover(hoverProps, monitor, hoverComponent) {
    let dragProps = monitor.getItem();

    if (!hoverProps.data || !dragProps.data) return;
    if (hoverProps.data.id == dragProps.data.id) return;

    dragProps.onChangeOrder(dragProps.data, hoverProps.data, 'sort_fields');
  },
};

function collectTarget(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
  };
}

var DecorateListItem = DragSource(
  'sort_list_item',
  itemSource,
  collectSource,
)(SortListItem);
DecorateListItem = DropTarget(
  'sort_list_item',
  itemTarget,
  collectTarget,
)(DecorateListItem);

export default DecorateListItem;
